import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=039a8fa4&scoped=true"
import script from "./PersonDetail.vue?vue&type=script&lang=js"
export * from "./PersonDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&id=039a8fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a8fa4",
  null
  
)

export default component.exports